import { Divider } from "@mui/material";
import Footer from "./components/Footer";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import Experience from "./components/Experience";
import WorkExperince from "./components/WorkExperience";
import About from "./components/About";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";

const theme = createTheme({
  typography: {
    fontFamily: "'Montserrat', sans-serif",
  },
  palette: {
    primary: {
      main: "#C68083", // Custom primary color
      h100: "#ECD5D6",
      h200: "#D9ABAD",
      h300: "#C68084",
      h400: "#B3565B", // denna!
      h500: "#8D3F43",
      h600: "#632C2F",
      white: "#fff",
      black: "#000",
    },
    secondary: {
      main: "#3A6073", // Custom primary color
      h100: "#C9DBE4",
      h200: "#A0BFCF",
      h300: "#77A4BB",
      h400: "#5288A3",
      h500: "#3E667A",
      h600: "#294451",
      h700: "#152229",
    },
    darkBlue: {
      main: "#213540", // Custom primary color
    },
  },
});

function App() {
  return (
    <>
      <ThemeProvider theme={theme}>
        <Navbar />
        <Hero />
        <Experience />
        <WorkExperince />
        <About />
        <Footer />
      </ThemeProvider>
    </>
  );
}

export default App;

/* 
"2px 2px 4px rgba(0, 0, 0, 0.5)", */
